import { render, staticRenderFns } from "./DcApprovalReject.vue?vue&type=template&id=6558b366&scoped=true"
import script from "./DcApprovalReject.vue?vue&type=script&lang=js"
export * from "./DcApprovalReject.vue?vue&type=script&lang=js"
import style0 from "./DcApprovalReject.vue?vue&type=style&index=0&id=6558b366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558b366",
  null
  
)

export default component.exports